import React, { useEffect, useState } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import VistaPreviaDocumentoSoportePDF from "./VistaPreviaDocumentoSoportePDF";
import axios from '../../axios/axiosconf';

function InformacionDocumentoSoporte() {
    const { id } = useParams();
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [documento, setDocumento] = useState(null);
    const [loading, setLoading] = useState(true);
    const [proveedores, setProveedores] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [cuentasPorPagar, setCuentasPorPagar] = useState([]);
    const [egresos, setEgresos] = useState([]);
    const [respuestaDian, setRespuestaDian] = useState(null);
    const [permisos, setPermisos] = useState([]);
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);
    const [creador, setCreador] = useState(null);
    const [fetchError, setFetchError] = useState(null);

    // Modal Abono
    const [showModalAbono, setShowModalAbono] = useState(false);
    const [valorAbono, setValorAbono] = useState('');
    const [observacionesAbono, setObservacionesAbono] = useState('');

    // Modal Anulación
    const [showModalAnulacion, setShowModalAnulacion] = useState(false);
    const [prefijoAnulacion, setPrefijoAnulacion] = useState('');
    const [motivoAnulacion, setMotivoAnulacion] = useState('');
    const [fechaAnulacion, setFechaAnulacion] = useState(new Date().toISOString().split('T')[0]);
    const [prefijosNota, setPrefijosNota] = useState([]);
    const [loadingNotaAnulacion, setLoadingNotaAnulacion] = useState(false);
    const [notasAnulacionExistentes, setNotasAnulacionExistentes] = useState([]);

    // Modal Debug
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState('');
    const [comprobandoEstadoDian, setComprobandoEstadoDian] = useState(false);
    const [ultimaComprobacionDian, setUltimaComprobacionDian] = useState(0);
    const COOLDOWN_COMPROBACION_MS = 30000;

    // Modal Vista Previa Egreso
    const [showModalEgreso, setShowModalEgreso] = useState(false);
    const [egresoSeleccionado, setEgresoSeleccionado] = useState(null);

    useEffect(() => {
        let userdata = {};
        try {
            const raw = localStorage.getItem('userdata');
            if (raw) userdata = JSON.parse(raw);
        } catch {
            userdata = {};
        }

        const tienePermiso = userdata.up && userdata.up.includes('ver_listado_documentos_soporte');

        if (!tienePermiso) {
            setHasPermission(false);
            setLoading(false);
            return;
        }

        setHasPermission(true);
        setPermisos(userdata.up || []);

        const uid = userdata.user_id;

        axios.get('/get-client?uid=' + uid)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/proveedores?uid=' + uid)
            .then(response => {
                if (response.status === 200) {
                    setProveedores(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/users-by-client?uid=' + uid)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        const numericId = id != null && String(id).trim() !== '' ? parseInt(String(id).trim(), 10) : NaN;

        if (!id || Number.isNaN(numericId)) {
            setDocumento(null);
            setFetchError('invalid_id');
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setFetchError(null);
        setDocumento(null);

        axios
            .get(`/documento-soporte/${numericId}`, {
                headers: { 'X-Suppress-403-Modal': 'true' },
            })
            .then(response => {
                if (cancelled) return;
                let d = response.data;
                if (d && typeof d === 'object' && d.data && typeof d.data === 'object' && !Array.isArray(d.data) && d.id == null) {
                    d = d.data;
                }
                const tieneClaveDocumento =
                    d &&
                    typeof d === 'object' &&
                    !Array.isArray(d) &&
                    (d.id != null || (d.prefijo != null && d.numero != null));
                if (response.status === 200 && tieneClaveDocumento) {
                    setDocumento(d);
                    setFetchError(null);
                    cargarCuentasPorPagar();
                    cargarEgresos(numericId);
                    if (parseInt(d.estado, 10) === 1) {
                        cargarRespuestaDian(numericId);
                    }
                    if (d.users_id) {
                        axios
                            .get(`/encabezado-personalizado?uid=${d.users_id}`)
                            .then(encResponse => {
                                if (cancelled) return;
                                if (encResponse.status === 200 && encResponse.data && encResponse.data.estado === 1) {
                                    setEncabezadoPersonalizado(encResponse.data);
                                } else {
                                    setEncabezadoPersonalizado(null);
                                }
                            })
                            .catch(() => {
                                if (!cancelled) setEncabezadoPersonalizado(null);
                            });
                    }
                } else {
                    setDocumento(null);
                    setFetchError('empty');
                }
            })
            .catch(error => {
                if (cancelled) return;
                setDocumento(null);
                const status = error.response?.status;
                if (status === 403) setFetchError('403');
                else if (status === 404) setFetchError('404');
                else if (status === 500) setFetchError('500');
                else setFetchError('other');
                console.error('Error cargando documento soporte:', error.response?.data || error.message);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [id]);

    useEffect(() => {
        if (!documento?.users_id) {
            setCreador(null);
            return;
        }
        const u = usuarios.find(x => String(x.id) === String(documento.users_id));
        setCreador(u || null);
    }, [documento, usuarios]);

    const cargarCuentasPorPagar = () => {
        axios.get('/cuentas-por-pagar')
            .then(response => {
                if (response.status === 200) {
                    setCuentasPorPagar(response.data);
                }
            })
            .catch(error => {
                console.log('Error al cargar cuentas por pagar: ' + error);
            });
    };

    const cargarEgresos = (documentoId) => {
        axios.get(`/egresos-documento-soporte/${documentoId}`)
            .then(response => {
                if (response.status === 200) {
                    setEgresos(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando egresos: ' + error);
            });
    };

    const cargarRespuestaDian = (documentoId) => {
        axios.get(`/documento-soporte/${documentoId}/respuesta-dian`)
            .then(response => {
                if (response.data.success) {
                    setRespuestaDian(response.data.data);
                }
            })
            .catch(error => {
                console.log('No hay respuesta DIAN para este documento');
            });
    };

    const getNombreProveedor = (proveedorId) => {
        const proveedor = proveedores.find(p => p.id === proveedorId);
        return proveedor ? proveedor.nombre_proveedor : 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id === usuarioId);
        return usuario ? usuario.name : 'N/A';
    };

    const getSaldoPendiente = () => {
        if (!documento) return 0;
        const cuenta = cuentasPorPagar.find(c => c.documento_soporte_id === documento.id);
        return cuenta ? parseFloat(cuenta.valor_pendiente || 0) : 0;
    };

    const getTipoPagoTexto = (tipoPago) => {
        switch(tipoPago) {
            case 'pagada': return 'Pagada';
            case 'por_pagar': return 'Por Pagar';
            default: return 'Pagada';
        }
    };

    const getTipoPagoColor = (tipoPago) => {
        switch(tipoPago) {
            case 'pagada': return 'badge badge-outline-success';
            case 'por_pagar': return 'badge badge-outline-warning';
            default: return 'badge badge-success';
        }
    };

    const getEstadoPagoDisplayDetalle = () => {
        if (!documento) return { texto: '', clase: 'badge badge-secondary' };
        if (parseInt(documento.estado, 10) === 2) {
            return { texto: 'No aplica', clase: 'badge badge-outline-secondary' };
        }
        const tipo = documento.tipo_pago || 'pagada';
        return { texto: getTipoPagoTexto(tipo), clase: getTipoPagoColor(tipo) };
    };

    const getEstadoTexto = (estado) => {
        switch(estado) {
            case 0: return 'Generado';
            case 1: return 'Enviado DIAN';
            case 2: return 'Anulado';
            case 3: return 'Error DIAN';
            default: return 'Desconocido';
        }
    };

    const getEstadoColor = (estado) => {
        switch(estado) {
            case 0: return 'badge badge-outline-secondary';
            case 1: return 'badge badge-outline-success';
            case 2: return 'badge badge-outline-danger';
            case 3: return 'badge badge-outline-danger';
            default: return 'badge badge-outline-secondary';
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const anio = String(date.getFullYear()).slice(-2);
        return `${dia}/${mes}/${anio}`;
    };

    const abrirModalAbono = () => {
        const saldoPendiente = getSaldoPendiente();
        
        if (saldoPendiente <= 0) {
            alert('Este documento no tiene saldo pendiente por pagar.');
            return;
        }

        setValorAbono('');
        setObservacionesAbono('');
        setShowModalAbono(true);
    };

    const realizarAbono = async () => {
        if (!valorAbono || parseFloat(valorAbono) <= 0) {
            alert('Por favor ingrese un valor válido para el abono.');
            return;
        }

        const saldoPendiente = getSaldoPendiente();
        const montoAbono = parseFloat(valorAbono);

        if (montoAbono > saldoPendiente) {
            alert(`El abono no puede ser mayor al saldo pendiente ($${saldoPendiente.toLocaleString('es-CO')})`);
            return;
        }

        if (!window.confirm(`¿Está seguro de realizar un abono de $${montoAbono.toLocaleString('es-CO')}?`)) {
            return;
        }

        try {
            const cuenta = cuentasPorPagar.find(c => c.documento_soporte_id === documento.id);
            
            if (!cuenta) {
                alert('No se encontró la cuenta por pagar para este documento.');
                return;
            }

            const response = await axios.post(`/cuenta-por-pagar/${cuenta.id}/abono`, {
                valor_abono: montoAbono,
                observaciones: observacionesAbono
            });
            
            if (response.status === 200 || response.status === 201) {
                const mensaje = response.data.estado === 'Pagada' 
                    ? `Abono de $${montoAbono.toLocaleString('es-CO')} realizado exitosamente.\nDocumento COMPLETAMENTE PAGADO.\nEgreso N° ${response.data.numero_egreso} generado.`
                    : `Abono de $${montoAbono.toLocaleString('es-CO')} realizado exitosamente.\nSaldo pendiente: $${response.data.saldo_pendiente.toLocaleString('es-CO')}\nEgreso N° ${response.data.numero_egreso} generado.`;
                
                alert(mensaje);
                setShowModalAbono(false);
                // Recargar datos
                cargarCuentasPorPagar();
                cargarEgresos(id);
                // Recargar documento
                let userdata = JSON.parse(localStorage.getItem('userdata'));
                axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`)
                    .then(response => {
                        if (response.status === 200) {
                            setDocumento(response.data);
                        }
                    });
            }
        } catch (error) {
            console.error('Error al realizar abono:', error);
            alert('Error al realizar abono: ' + (error.response?.data?.message || error.message));
        }
    };

    const generarEgresoCompleto = async () => {
        if (!window.confirm('¿Está seguro de generar un egreso para cancelar esta cuenta por pagar?')) {
            return;
        }

        try {
            const response = await axios.post('/documento-soporte/generar-egreso', {
                documento_soporte_id: documento.id
            });
            
            if (response.status === 200 || response.status === 201) {
                alert(`Egreso N° ${response.data.numero_egreso} generado exitosamente.\nDocumento marcado como PAGADA.`);
                // Recargar datos
                cargarCuentasPorPagar();
                cargarEgresos(id);
                let userdata = JSON.parse(localStorage.getItem('userdata'));
                axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`)
                    .then(response => {
                        if (response.status === 200) {
                            setDocumento(response.data);
                        }
                    });
            }
        } catch (error) {
            console.error('Error al generar egreso:', error);
            alert('Error al generar egreso: ' + (error.response?.data?.message || error.message));
        }
    };

    const abrirModalAnulacion = async () => {
        // Estado generado (0): sin envío DIAN → anular en sistema (igual que anulación provisional)
        if (parseInt(documento.estado, 10) === 0) {
            if (!window.confirm('¿Anular este documento soporte? No ha sido enviado a la DIAN; se marcará como anulado sin nota electrónica.')) {
                return;
            }

            try {
                const response = await axios.post(`/documento-soporte/${documento.id}/anulacion-provisional`, {});

                if (response.status === 200) {
                    alert('Documento soporte anulado correctamente.');
                    history.push('/listado-documentos-soporte');
                }
            } catch (error) {
                alert('Error al anular el documento: ' + (error.response?.data?.message || error.message));
            }
            return;
        }

        // Si está enviado a DIAN (estado 1), cargar prefijos y notas previas
        if (parseInt(documento.estado, 10) === 1) {
            let userdata = JSON.parse(localStorage.getItem('userdata'));

            setPrefijoAnulacion('');
            setMotivoAnulacion('');
            setNotasAnulacionExistentes([]);

            try {
                const [prefijosRes, notasRes] = await Promise.all([
                    axios.get('/parametros-fev?uid=' + userdata.user_id),
                    axios.get(`/nota-documento-soporte/por-documento/${documento.id}?uid=${userdata.user_id}`),
                ]);

                if (prefijosRes.status === 200) {
                    const prefijosFiltrados = prefijosRes.data.filter(p =>
                        p.tipo === 'Nota Documento Soporte' &&
                        p.estado == 1 &&
                        Number(p.habilitado) > 0
                    );
                    setPrefijosNota(prefijosFiltrados);
                    if (prefijosFiltrados.length === 0) {
                        alert('No hay resolución «Nota Documento Soporte» activa con cupo (habilitado > 0). En Parámetros FEV asigne cupos a esa resolución; si habilitado=0 el envío a DIAN falla.');
                        return;
                    }
                }

                if (notasRes.status === 200) {
                    const notas = notasRes.data?.notas || [];
                    setNotasAnulacionExistentes(notas);

                    if (notas.length > 0) {
                        alert('Este documento soporte ya tiene una nota de anulación registrada. Actualice la página antes de intentar otra. Si acaba de enviar una nota y la DIAN tardó, espere unos segundos y recargue.');
                        return;
                    }
                }

                setShowModalAnulacion(true);
            } catch (error) {
                alert('Error al cargar datos de anulación: ' + (error.response?.data?.message || error.message));
            }
        } else {
            alert('Solo se pueden anular documentos en estado Borrador o Enviado a DIAN');
        }
    };

    const generarNotaAnulacion = async () => {
        if (loadingNotaAnulacion) return;

        if (!prefijoAnulacion) {
            alert('Por favor seleccione un prefijo');
            return;
        }

        if (!fechaAnulacion) {
            alert('Por favor seleccione una fecha');
            return;
        }

        if (notasAnulacionExistentes.length > 0) {
            alert('Este documento soporte ya tiene nota de anulación. Actualice la página antes de reintentar.');
            return;
        }

        if (!window.confirm('¿Está seguro de generar una Nota de Documento Soporte para anular? Esta acción no se puede deshacer.\n\nSi la DIAN tarda en responder, no envíe otra nota: espere y actualice la página.')) {
            return;
        }

        setLoadingNotaAnulacion(true);
        try {
            const envioResponse = await axios.post('/nota-documento-soporte/enviar-dian-directo', {
                documento_soporte_id: documento.id,
                parametrosfev_id: parseInt(prefijoAnulacion),
                motivo_observacion: motivoAnulacion || 'Anulación de documento soporte',
                fecha_emision: fechaAnulacion
            });
            
            setShowModalAnulacion(false);
            
            if (envioResponse.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Nota de documento soporte enviada exitosamente a la DIAN',
                    cufe: envioResponse.data.uuid
                });
                setShowModalDebug(true);
                let userdata = JSON.parse(localStorage.getItem('userdata'));
                axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`)
                    .then(response => {
                        if (response.status === 200) {
                            setDocumento(response.data);
                        }
                    });
            } else {
                setDebugType('error');
                setDebugData({
                    message: envioResponse.data.message,
                    response: envioResponse.data.response,
                    json_enviado: envioResponse.data.json_enviado,
                    status_code: envioResponse.data.status_code
                });
                setShowModalDebug(true);
            }
            
        } catch (error) {
            console.error('Error al enviar nota a DIAN:', error);
            setShowModalAnulacion(false);
            
            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data
            });
            setShowModalDebug(true);
        } finally {
            setLoadingNotaAnulacion(false);
        }
    };

    const enviarDian = async () => {
        if (!window.confirm('¿Está seguro de enviar este documento a la DIAN?')) {
            return;
        }

        try {
            const response = await axios.post(`/documento-soporte/${documento.id}/enviar-dian`, {});
            
            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Documento soporte enviado exitosamente a la DIAN',
                    cufe: response.data.uuid,
                    estado: response.data.estado
                });
                setShowModalDebug(true);
                // Recargar documento
                let userdata = JSON.parse(localStorage.getItem('userdata'));
                axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`)
                    .then(response => {
                        if (response.status === 200) {
                            setDocumento(response.data);
                        }
                    });
            } else {
                setDebugType('error');
                setDebugData({
                    message: response.data.message,
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code
                });
                setShowModalDebug(true);
            }
        } catch (error) {
            console.error('Error al enviar a DIAN:', error);
            
            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data
            });
            setShowModalDebug(true);
        }
    };

    const recargarDocumento = () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`)
            .then(response => {
                if (response.status === 200) {
                    setDocumento(response.data);
                }
            });
        axios.get(`/documento-soporte/${id}/respuesta-dian`)
            .then(response => {
                if (response.data?.success && response.data?.data) {
                    setRespuestaDian(response.data.data);
                }
            })
            .catch(() => {});
    };

    const comprobarEstadoDian = async () => {
        if (!documento?.id) return;

        const ahora = Date.now();
        const tiempoRestante = Math.ceil((COOLDOWN_COMPROBACION_MS - (ahora - ultimaComprobacionDian)) / 1000);
        if (ahora - ultimaComprobacionDian < COOLDOWN_COMPROBACION_MS) {
            alert(`Por favor espere ${tiempoRestante} segundos antes de volver a comprobar.`);
            return;
        }

        setComprobandoEstadoDian(true);
        setUltimaComprobacionDian(ahora);

        try {
            const response = await axios.post(`/documento-soporte/${documento.id}/comprobar-estado-dian`);

            if (response.data.success) {
                const detalle = response.data.uuid ? `\nCUDS/UUID: ${response.data.uuid}` : '';
                alert((response.data.message || 'Estado actualizado correctamente') + detalle);
                recargarDocumento();
            } else {
                setDebugType('error');
                setDebugData({
                    titulo: 'Resultado consulta DIAN',
                    message: (response.data.message || 'No se pudo confirmar el estado.') +
                        '\n\nSi el documento existe en la DIAN, intente de nuevo en unos minutos. Si no existe, use «Enviar a DIAN».',
                    response: response.data.debug?.respuesta || null,
                    json_enviado: response.data.debug?.consulta || null,
                });
                setShowModalDebug(true);
            }
        } catch (error) {
            setDebugType('error');
            setDebugData({
                titulo: 'Error al consultar DIAN',
                message: error.response?.data?.message || 'Error de conexión con el servidor.',
                response: error.response?.data || null,
            });
            setShowModalDebug(true);
            console.error('Error al comprobar estado DIAN:', error);
        } finally {
            setComprobandoEstadoDian(false);
        }
    };

    // Función para abrir modal de vista previa de egreso
    const abrirModalEgreso = (egreso) => {
        setEgresoSeleccionado(egreso);
        setShowModalEgreso(true);
    };

    // Función para imprimir egreso - abre vista previa
    const imprimirEgreso = () => {
        if (!egresoSeleccionado) return;
        // Abrir vista previa en nueva ventana
        // El usuario puede usar Ctrl+P o el botón de imprimir de la página
        window.open(`/smile/#/vista-previa-egreso/${egresoSeleccionado.id}`, '_blank');
    };

    // 🆕 Función para generar PDF editable del documento soporte
    const generarPDFEditable = async () => {
        try {
            // Crear contenedor temporal
            const contenedorTemporal = document.createElement('div');
            contenedorTemporal.style.position = 'absolute';
            contenedorTemporal.style.left = '-9999px';
            contenedorTemporal.style.top = '0';
            document.body.appendChild(contenedorTemporal);
            
            // Obtener proveedor
            const proveedor = proveedores.find(p => p.id === documento.proveedor_id);
            
            // Renderizar componente PDF
            ReactDOM.render(
                <VistaPreviaDocumentoSoportePDF
                    documento={documento}
                    client={client}
                    proveedor={proveedor}
                    encabezadoPersonalizado={encabezadoPersonalizado}
                    creador={creador}
                />,
                contenedorTemporal
            );
            
            // Esperar a que se renderice
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Generar PDF
            const html2pdf = await import('html2pdf-fix-jspdf');
            const element = document.getElementById('documento-soporte-pdf-editable');
            
            const opt = {
                margin: 10,
                filename: `documento-soporte-${documento.prefijo}-${documento.numero}.pdf`,
                image: { type: 'jpeg', quality: 0.95 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    letterRendering: true
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'letter',
                    orientation: 'portrait',
                    compress: true
                },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                }
            };
            
            // Generar y guardar el PDF directamente
            await html2pdf.default().from(element).set(opt).save();
            
            // Limpiar
            document.body.removeChild(contenedorTemporal);
            
        } catch (error) {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intente nuevamente.');
        }
    };

    // 🆕 Función para imprimir PDF editable del documento soporte
    const imprimirPDFEditable = async () => {
        try {
            // Crear contenedor temporal
            const contenedorTemporal = document.createElement('div');
            contenedorTemporal.style.position = 'absolute';
            contenedorTemporal.style.left = '-9999px';
            contenedorTemporal.style.top = '0';
            document.body.appendChild(contenedorTemporal);
            
            // Obtener proveedor
            const proveedor = proveedores.find(p => p.id === documento.proveedor_id);
            
            // Renderizar componente PDF
            ReactDOM.render(
                <VistaPreviaDocumentoSoportePDF
                    documento={documento}
                    client={client}
                    proveedor={proveedor}
                    encabezadoPersonalizado={encabezadoPersonalizado}
                    creador={creador}
                />,
                contenedorTemporal
            );
            
            // Esperar a que se renderice
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Generar PDF y abrir ventana de impresión
            const html2pdf = await import('html2pdf-fix-jspdf');
            const element = document.getElementById('documento-soporte-pdf-editable');
            
            const opt = {
                margin: 10,
                filename: `documento-soporte-${documento.prefijo}-${documento.numero}.pdf`,
                image: { type: 'jpeg', quality: 0.95 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    letterRendering: true
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'letter',
                    orientation: 'portrait',
                    compress: true
                },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                }
            };
            
            // Generar PDF como blob para imprimir
            const pdf = await html2pdf.default().from(element).set(opt).outputPdf('blob');
            const pdfBlob = new Blob([pdf], { type: 'application/pdf' });
            const url = URL.createObjectURL(pdfBlob);
            
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);
            
            iframe.onload = () => {
                // Esperar 500ms antes de abrir el diálogo de impresión
                setTimeout(() => {
                    iframe.contentWindow.print();
                }, 500);
                
                // Limpiar después de 60 segundos
                setTimeout(() => {
                    if (document.body.contains(iframe)) {
                        document.body.removeChild(iframe);
                        URL.revokeObjectURL(url);
                    }
                }, 60000);
            };
            
            // Limpiar contenedor temporal
            document.body.removeChild(contenedorTemporal);
            
        } catch (error) {
            console.error('Error imprimiendo PDF:', error);
            alert('Error al imprimir el PDF. Por favor, intente nuevamente.');
        }
    };

    // 🔒 PROTECCIÓN DE RUTA
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loading) {
        return <Loading />;
    }

    if (!documento) {
        const textoDetalle =
            fetchError === '403'
                ? 'No tiene permisos para ver este documento o no pertenece a su cliente.'
                : fetchError === '404'
                  ? 'No existe un documento con ese identificador.'
                  : fetchError === '500'
                    ? 'Error en el servidor al cargar el documento. Si acaba de actualizar el sistema, avise al administrador.'
                    : fetchError === 'invalid_id'
                      ? 'La dirección del documento no es válida.'
                      : fetchError === 'empty'
                        ? 'El servidor no devolvió datos del documento.'
                        : 'No fue posible cargar el documento. Si el problema continúa, verifique su sesión y la conexión.';

        return (
            <div className="hold-transition ids-doc-soporte-info">
                <style>{`
                    .ids-doc-soporte-info .ids-empty-state { max-width: 520px; }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                <div className="content-wrapper">
                    <div className="content-header pb-2">
                        <div className="container-fluid ids-empty-state">
                            <h1 className="m-0" style={{ fontWeight: 800, fontSize: '1.5rem', color: '#323a45' }}>No se pudo mostrar el documento</h1>
                            <p className="text-muted mt-2 mb-0" style={{ fontSize: '0.9rem' }}>{textoDetalle}</p>
                            <Link to="/listado-documentos-soporte" className="btn btn-info mt-3" style={{ borderRadius: '10px' }}>
                                <i className="fas fa-arrow-left mr-2"></i>
                                Volver al listado
                            </Link>
                        </div>
                    </div>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    const saldoPendiente = getSaldoPendiente();
    const estadoPagoDetalle = getEstadoPagoDisplayDetalle();
    const documentoAnuladoDian = parseInt(documento.estado, 10) === 2;

    return (
        <div className="hold-transition ids-doc-soporte-info" style={{ fontSize: '13px' }}>
            <style>{`
                .ids-doc-soporte-info .content-header h1 { font-size: 1.5rem !important; font-weight: 800 !important; color: #323a45 !important; }
                .ids-doc-soporte-info .ids-soft-card {
                    border-radius: 16px !important;
                    border: 1px solid rgba(0,0,0,0.06) !important;
                    box-shadow: 0 4px 18px rgba(0,0,0,0.05) !important;
                    overflow: hidden;
                    margin-bottom: 1.25rem;
                }
                .ids-doc-soporte-info .ids-soft-card .card-header {
                    background: #f8f9fa !important;
                    border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                    padding: 0.85rem 1.15rem;
                }
                .ids-doc-soporte-info .ids-soft-card .card-title {
                    margin: 0;
                    font-size: 1rem;
                    font-weight: 800;
                    color: #323a45;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
                .ids-doc-soporte-info .ids-soft-card .card-title .fa,
                .ids-doc-soporte-info .ids-soft-card .card-title .fas { color: #17a2b8; }
                .ids-doc-soporte-info .ids-kv-table td:first-child {
                    color: #6c757d;
                    font-size: 0.76rem;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.03em;
                    width: 42%;
                    vertical-align: middle;
                }
                .ids-doc-soporte-info .ids-kv-table td:last-child {
                    color: #323a45;
                    font-size: 0.9rem;
                    vertical-align: middle;
                }
                .ids-doc-soporte-info .ids-alert-info-soft {
                    border-radius: 12px;
                    border: 1px solid rgba(23, 162, 184, 0.28);
                    background: rgba(23, 162, 184, 0.09);
                    color: #0c5460;
                    padding: 12px 14px;
                    font-size: 0.875rem;
                }
                .ids-doc-soporte-info .ids-alert-info-soft code { background: rgba(255,255,255,0.6); padding: 2px 6px; border-radius: 4px; font-size: 0.8rem; }
                .ids-doc-soporte-info .ids-preview-card .card-header {
                    background: #f6fcfd !important;
                    border-bottom: 1px solid rgba(23, 162, 184, 0.2) !important;
                }
                .ids-doc-soporte-info .ids-preview-card .card-tools .btn { border-radius: 8px; font-size: 0.8rem; }
                .ids-doc-soporte-info .ids-soft-table thead th {
                    background: #f8f9fa !important;
                    color: #7d7d7d !important;
                    text-transform: uppercase;
                    font-size: 0.7rem !important;
                    font-weight: 700 !important;
                    padding: 12px 14px !important;
                    border: none !important;
                    border-bottom: 1px solid #eee !important;
                }
                .ids-doc-soporte-info .ids-soft-table tbody td {
                    font-size: 0.85rem;
                    vertical-align: middle;
                    padding: 10px 14px !important;
                    border-color: #f0f0f0 !important;
                }
                .ids-doc-soporte-info .ids-json-pre {
                    background: #f8f9fa;
                    padding: 14px;
                    border-radius: 10px;
                    max-height: 400px;
                    overflow: auto;
                    font-size: 12px;
                    border: 1px solid rgba(0,0,0,0.06);
                }
                .ids-doc-soporte-info .ids-ds-modal .modal-content {
                    border-radius: 16px !important;
                    border: 1px solid rgba(0,0,0,0.08) !important;
                    box-shadow: 0 12px 32px rgba(0,0,0,0.08) !important;
                    overflow: hidden;
                }
                .ids-doc-soporte-info .ids-ds-modal .modal-header.ids-ds-head {
                    background: #f8f9fa !important;
                    border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                }
                .ids-doc-soporte-info .ids-ds-modal .modal-header.ids-ds-head .modal-title { font-size: 1rem; font-weight: 700; color: #323a45; }
                .ids-doc-soporte-info .ids-ds-modal .modal-header.ids-ds-head-error {
                    background: #f8f9fa !important;
                    border-bottom: 3px solid #dc3545 !important;
                }
                .ids-doc-soporte-info .ids-ds-alert-caution {
                    border-radius: 12px;
                    border: 1px solid rgba(212, 167, 44, 0.35);
                    background: linear-gradient(180deg, #fffdf8 0%, #fff8ec 100%);
                    color: #5c4508;
                    padding: 12px 14px;
                    font-size: 0.875rem;
                }
                .ids-doc-soporte-info .ids-ds-alert-success-soft {
                    border-radius: 12px;
                    border: 1px solid rgba(40, 167, 69, 0.32);
                    background: rgba(40, 167, 69, 0.09);
                    color: #155724;
                    padding: 12px 14px;
                    font-size: 0.875rem;
                }
                .ids-doc-soporte-info .ids-debug-card {
                    border-radius: 12px !important;
                    border: 1px solid rgba(0,0,0,0.08) !important;
                    overflow: hidden;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.04) !important;
                }
                .ids-doc-soporte-info .ids-debug-card .card-header {
                    background: #f8f9fa !important;
                    border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                    color: #323a45 !important;
                    font-weight: 700;
                }
                .badge-outline {
                    background-color: transparent;
                    border-width: 1px;
                    border-style: solid;
                }
                .badge-outline-secondary { color: #6c757d; border: 1px solid #6c757d; background-color: transparent; }
                .badge-outline-success { color: #28a745; border: 1px solid #28a745; background-color: transparent; }
                .badge-outline-danger { color: #dc3545; border: 1px solid #dc3545; background-color: transparent; }
                .badge-outline-warning { color: #d39e00; border: 1px solid rgba(255, 193, 7, 0.65); background-color: transparent; }
            `}</style>
            <Header client={client} />
            <Aside client={client} activelink="billing" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left">
                                    <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                    <li className="breadcrumb-item"><Link to="/listado-documentos-soporte">Documentos Soporte</Link></li>
                                    <li className="breadcrumb-item active">Información</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-center">
                            <div className="col-sm-12 col-md-8">
                                <h1 className="m-0">Documento soporte N° {documento.prefijo}-{documento.numero}</h1>
                                <p className="mb-0 mt-1 text-muted" style={{ fontSize: '0.8rem' }}>
                                    <span className="badge" style={{ background: 'rgba(23,162,184,0.1)', color: '#117f90', border: '1px solid rgba(23,162,184,0.2)', borderRadius: '999px', fontWeight: 700, fontSize: '0.72rem' }}>Detalle</span>
                                </p>
                            </div>
                            <div className="col-sm-12 col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link to="/listado-documentos-soporte" className="btn btn-info" style={{ borderRadius: '10px' }}>
                                    <i className="fas fa-arrow-left mr-2"></i> Volver al listado
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        {/* Card de Información General */}
                        <div className="card ids-soft-card shadow-sm border-0">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-info-circle"></i> Información general</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <table className="table table-sm table-borderless ids-kv-table mb-0">
                                            <tbody>
                                                <tr>
                                                    <td>N° documento</td>
                                                    <td><strong>{documento.prefijo}-{documento.numero}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>Fecha emisión</td>
                                                    <td>{formatearFecha(documento.fecha_emision)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Proveedor</td>
                                                    <td>{getNombreProveedor(documento.proveedor_id)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Usuario</td>
                                                    <td>{getNombreUsuario(documento.users_id)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-md-6">
                                        <table className="table table-sm table-borderless ids-kv-table mb-0">
                                            <tbody>
                                                <tr>
                                                    <td>Estado</td>
                                                    <td>
                                                        <span className={`badge ${getEstadoColor(parseInt(documento.estado, 10))}`}>
                                                            {getEstadoTexto(parseInt(documento.estado, 10))}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Estado pago</td>
                                                    <td>
                                                        <span className={estadoPagoDetalle.clase} title={documentoAnuladoDian ? 'Documento anulado: el estado de pago no aplica' : ''}>
                                                            {estadoPagoDetalle.texto}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Valor total</td>
                                                    <td className="text-success font-weight-bold">
                                                        ${Math.round(parseFloat(documento.valor_total)).toLocaleString('es-CO')}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Saldo pendiente</td>
                                                    <td className={documentoAnuladoDian ? 'text-muted' : saldoPendiente > 0 ? 'text-danger font-weight-bold' : 'text-success font-weight-bold'}>
                                                        {documentoAnuladoDian ? '—' : `$${Math.round(saldoPendiente).toLocaleString('es-CO')}`}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {documento.uuid && (
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <div className="ids-alert-info-soft mb-0">
                                                <strong>CUFE / UUID:</strong> <code>{documento.uuid}</code>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Card de Acciones */}
                        <div className="card ids-soft-card shadow-sm border-0">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-cogs"></i> Acciones</h3>
                            </div>
                            <div className="card-body">
                                <div className="btn-toolbar" role="toolbar">
                                    <div className="btn-group mr-2 mb-2" role="group">
                                        <button 
                                            className="btn btn-info"
                                            style={{ borderRadius: '10px' }}
                                            onClick={() => window.open(`/#/vista-previa-documento-soporte/${documento.id}`, '_blank')}
                                            title="Vista previa e impresión"
                                        >
                                            <i className="fas fa-eye mr-1"></i> Vista previa
                                        </button>
                                    </div>

                                    {/* Botones según estado y tipo de pago */}
                                    {!documentoAnuladoDian && documento.tipo_pago === 'por_pagar' && saldoPendiente > 0 && (
                                        <>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-primary"
                                                    onClick={abrirModalAbono}
                                                    title="Realizar Abono Parcial"
                                                >
                                                    <i className="fas fa-coins"></i> Realizar Abono
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-primary"
                                                    onClick={generarEgresoCompleto}
                                                    title="Pagar Saldo Completo"
                                                >
                                                    <i className="fas fa-money-bill-wave"></i> Pagar Todo
                                                </button>
                                            </div>
                                        </>
                                    )}

                                    {/* Estado 0: Generado */}
                                    {parseInt(documento.estado, 10) === 0 && (
                                        <>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-outline-danger"
                                                    onClick={abrirModalAnulacion}
                                                    title="Anular Documento"
                                                >
                                                    <i className="fas fa-ban"></i> Anular
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-primary"
                                                    onClick={enviarDian}
                                                    title="Enviar a la DIAN"
                                                >
                                                    <i className="fas fa-paper-plane"></i> Enviar a DIAN
                                                </button>
                                            </div>
                                        </>
                                    )}
                                    
                                    {/* Estado 1: Enviado DIAN */}
                                    {parseInt(documento.estado, 10) === 1 && (
                                        <div className="btn-group mr-2 mb-2" role="group">
                                            <button 
                                                className="btn btn-outline-danger"
                                                onClick={abrirModalAnulacion}
                                                title="Generar Nota de Anulación"
                                            >
                                                <i className="fas fa-file-invoice"></i> Nota Anulación
                                            </button>
                                        </div>
                                    )}
                                    
                                    {/* Estado 3: Error DIAN */}
                                    {parseInt(documento.estado, 10) === 3 && (
                                        <>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-outline-danger"
                                                    onClick={abrirModalAnulacion}
                                                    title="Anular Documento"
                                                >
                                                    <i className="fas fa-ban"></i> Anular
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button
                                                    className="btn btn-outline-info"
                                                    onClick={comprobarEstadoDian}
                                                    disabled={comprobandoEstadoDian}
                                                    title="Consultar si ya existe en la DIAN y actualizar estado"
                                                >
                                                    <i className={`fas ${comprobandoEstadoDian ? 'fa-spinner fa-spin' : 'fa-sync-alt'}`}></i>
                                                    {' '}{comprobandoEstadoDian ? 'Comprobando…' : 'Verificar en DIAN'}
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-primary"
                                                    onClick={enviarDian}
                                                    title="Reintentar envío a la DIAN"
                                                >
                                                    <i className="fas fa-redo"></i> Enviar a DIAN
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* 🆕 Vista Previa del Documento Soporte */}
                        <div className="card ids-soft-card ids-preview-card shadow-sm border-0" id="vista-previa-documento-container">
                            <div className="card-header no-print">
                                <h3 className="card-title">
                                    <i className="fas fa-file-invoice"></i> Vista previa del documento
                                </h3>
                                <div className="card-tools">
                                    <button
                                        className="btn btn-sm btn-primary mr-1"
                                        onClick={imprimirPDFEditable}
                                        title="Imprimir documento en formato PDF"
                                    >
                                        <i className="fas fa-print mr-1"></i> Imprimir
                                    </button>
                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={generarPDFEditable}
                                        title="Descargar documento en formato PDF"
                                    >
                                        <i className="fas fa-file-pdf mr-1"></i> PDF
                                    </button>
                                </div>
                            </div>
                            <div className="card-body" id="vista-previa-documento-content">
                                <VistaPreviaDocumentoSoportePDF
                                    documento={documento}
                                    client={client}
                                    proveedor={proveedores.find(p => p.id === documento?.proveedor_id)}
                                    encabezadoPersonalizado={encabezadoPersonalizado}
                                    creador={creador}
                                />
                            </div>
                        </div>

                        {/* Card de Egresos Asociados */}
                        {egresos.length > 0 && (
                            <div className="card ids-soft-card shadow-sm border-0">
                                <div className="card-header">
                                    <h3 className="card-title"><i className="fas fa-money-bill-wave"></i> Egresos asociados</h3>
                                </div>
                                <div className="card-body p-0">
                                    <table className="table table-hover ids-soft-table mb-0">
                                        <thead>
                                            <tr>
                                                <th>N° Egreso</th>
                                                <th>Fecha</th>
                                                <th>Valor</th>
                                                <th>Estado</th>
                                                <th>Observaciones</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {egresos.map(egreso => (
                                                <tr key={egreso.id}>
                                                    <td><strong>{egreso.numero || 'N/A'}</strong></td>
                                                    <td>{formatearFecha(egreso.fecha_creacion)}</td>
                                                    <td className="text-right font-weight-bold">
                                                        ${Math.round(parseFloat(egreso.valor_total || 0)).toLocaleString('es-CO')}
                                                    </td>
                                                    <td>
                                                        {egreso.estado === 0 ? (
                                                            <span className="badge badge-success">Activo</span>
                                                        ) : egreso.estado === 1 ? (
                                                            <span className="badge badge-danger">Anulado</span>
                                                        ) : (
                                                            <span className="badge badge-secondary">Desconocido</span>
                                                        )}
                                                    </td>
                                                    <td>{egreso.observaciones || '-'}</td>
                                                    <td className="text-center">
                                                        <button
                                                            className="btn btn-sm btn-info"
                                                            onClick={() => abrirModalEgreso(egreso)}
                                                            title="Ver Egreso"
                                                        >
                                                            <i className="fas fa-eye"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Card de Respuesta DIAN */}
                        {respuestaDian && (
                            <div className="card ids-soft-card shadow-sm border-0">
                                <div className="card-header">
                                    <h3 className="card-title"><i className="fas fa-server"></i> Respuesta DIAN</h3>
                                </div>
                                <div className="card-body">
                                    <pre className="ids-json-pre mb-0">
                                        {JSON.stringify(respuestaDian, null, 2)}
                                    </pre>
                                </div>
                            </div>
                        )}

                    </div>
                </section>
            </div>

            {/* Modal Abono */}
            {showModalAbono && (
                <div className="modal fade show ids-ds-modal" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.45)'}} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content border-0">
                            <div className="modal-header ids-ds-head">
                                <h4 className="modal-title">
                                    <i className="fas fa-coins mr-2 text-info"></i>Realizar abono
                                </h4>
                                <button type="button" className="close" onClick={() => setShowModalAbono(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="ids-alert-info-soft mb-3">
                                    <i className="fas fa-info-circle mr-1"></i> Puede realizar abonos parciales desde $1 hasta el saldo pendiente.
                                </div>
                                
                                <div className="form-group">
                                    <label>Documento</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={`${documento.prefijo}-${documento.numero}`}
                                        readOnly
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Valor Total</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={`$${Math.round(parseFloat(documento.valor_total)).toLocaleString('es-CO')}`}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Saldo Pendiente</label>
                                            <input 
                                                type="text" 
                                                className="form-control text-warning font-weight-bold" 
                                                value={`$${Math.round(saldoPendiente).toLocaleString('es-CO')}`}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label>Valor del Abono *</label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">$</span>
                                        </div>
                                        <input 
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Ingrese el valor del abono"
                                            value={valorAbono}
                                            onChange={(e) => setValorAbono(e.target.value)}
                                            min="1"
                                            max={saldoPendiente}
                                            step="0.01"
                                            required
                                        />
                                    </div>
                                    <small className="form-text text-muted">
                                        Mínimo: $1 - Máximo: ${Math.round(saldoPendiente).toLocaleString('es-CO')}
                                    </small>
                                </div>
                                
                                <div className="form-group">
                                    <label>Observaciones</label>
                                    <textarea 
                                        className="form-control" 
                                        rows="3"
                                        value={observacionesAbono}
                                        onChange={(e) => setObservacionesAbono(e.target.value)}
                                        placeholder="Observaciones del abono (opcional)..."
                                    ></textarea>
                                </div>

                                {valorAbono && parseFloat(valorAbono) > 0 && (
                                    <div className="ids-ds-alert-success-soft mb-0">
                                        <strong>Resumen del abono</strong><br/>
                                        • Valor a abonar: <strong>${parseFloat(valorAbono).toLocaleString('es-CO')}</strong><br/>
                                        • Saldo después del abono: <strong>${(saldoPendiente - parseFloat(valorAbono)).toLocaleString('es-CO')}</strong><br/>
                                        • Se generará: <strong>egreso automático</strong>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalAbono(false)}>
                                    Cancelar
                                </button>
                                <button 
                                    type="button" 
                                    className="btn btn-info" 
                                    onClick={realizarAbono}
                                    disabled={!valorAbono || parseFloat(valorAbono) <= 0}
                                >
                                    <i className="fas fa-coins"></i> Realizar Abono
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Anulación */}
            {showModalAnulacion && (
                <div className="modal fade show ids-ds-modal" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.45)'}} tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content border-0">
                            <div className="modal-header ids-ds-head-error">
                                <h4 className="modal-title">
                                    <i className="fas fa-ban mr-2 text-danger"></i>Anular documento soporte
                                </h4>
                                <button type="button" className="close" onClick={() => setShowModalAnulacion(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="ids-ds-alert-caution mb-3">
                                    <i className="fas fa-exclamation-triangle mr-1"></i> Esta acción generará una nota de documento soporte y anulará el documento original.
                                </div>

                                {notasAnulacionExistentes.length > 0 && (
                                    <div className="ids-ds-alert-caution mb-3">
                                        <strong>Nota de anulación ya registrada:</strong>
                                        <ul className="mb-0 mt-2 pl-3 small">
                                            {notasAnulacionExistentes.map((nota) => (
                                                <li key={nota.id}>
                                                    {nota.prefijo || ''}{nota.numero_nc || '—'}
                                                    {nota.uuid ? ' · DIAN OK' : ''}
                                                </li>
                                            ))}
                                        </ul>
                                        <p className="mb-0 mt-2 small text-muted">
                                            Solo puede existir una nota de anulación por documento soporte enviado a DIAN.
                                        </p>
                                    </div>
                                )}
                                
                                <div className="form-group">
                                    <label>Documento a Anular</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={`${documento.prefijo}${documento.numero}`}
                                        readOnly
                                    />
                                </div>
                                
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Prefijo Nota *</label>
                                            <select 
                                                className="form-control" 
                                                value={prefijoAnulacion}
                                                onChange={(e) => setPrefijoAnulacion(e.target.value)}
                                                required
                                            >
                                                <option value="">Seleccionar...</option>
                                                {prefijosNota.map(p => (
                                                    <option key={p.id} value={p.id}>{p.prefijo}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>N° Nota</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={prefijosNota.find(p => p.id == prefijoAnulacion)?.numero_factura || ''}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Fecha Anulación *</label>
                                            <input 
                                                type="date" 
                                                className="form-control" 
                                                value={fechaAnulacion}
                                                onChange={(e) => setFechaAnulacion(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label>Motivo de Anulación</label>
                                    <textarea 
                                        className="form-control" 
                                        rows="3"
                                        value={motivoAnulacion}
                                        onChange={(e) => setMotivoAnulacion(e.target.value)}
                                        placeholder="Ingrese el motivo de la anulación..."
                                    ></textarea>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalAnulacion(false)} disabled={loadingNotaAnulacion}>Cancelar</button>
                                <button type="button" className="btn btn-danger" onClick={generarNotaAnulacion} disabled={loadingNotaAnulacion || notasAnulacionExistentes.length > 0}>
                                    {loadingNotaAnulacion ? (
                                        <><i className="fas fa-spinner fa-spin mr-1"></i> Enviando…</>
                                    ) : (
                                        <><i className="fas fa-ban mr-1"></i> Generar Nota y Anular</>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Vista Previa Egreso */}
            {showModalEgreso && egresoSeleccionado && (
                <div className="modal fade show ids-ds-modal" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.45)'}} tabIndex="-1">
                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                        <div className="modal-content border-0">
                            <div className="modal-header ids-ds-head">
                                <h4 className="modal-title">
                                    <i className="fas fa-money-bill-wave mr-2 text-info"></i>Egreso N° {egresoSeleccionado.numero}
                                </h4>
                                <button type="button" className="close" onClick={() => setShowModalEgreso(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="card ids-debug-card border-0 shadow-none">
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <table className="table table-sm table-borderless ids-kv-table mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td>N° egreso</td>
                                                            <td><strong>{egresoSeleccionado.numero}</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Fecha</td>
                                                            <td>{formatearFecha(egresoSeleccionado.fecha_creacion)}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Método de pago</td>
                                                            <td>{egresoSeleccionado.metodo_pago || 'N/A'}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="col-md-6">
                                                <table className="table table-sm table-borderless ids-kv-table mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td>Estado</td>
                                                            <td>
                                                                {egresoSeleccionado.estado === 0 ? (
                                                                    <span className="badge badge-success">Activo</span>
                                                                ) : (
                                                                    <span className="badge badge-danger">Anulado</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Valor total</td>
                                                            <td className="text-success font-weight-bold">
                                                                ${Math.round(parseFloat(egresoSeleccionado.valor_total || 0)).toLocaleString('es-CO')}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Usuario</td>
                                                            <td>{getNombreUsuario(egresoSeleccionado.users_id)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {egresoSeleccionado.observaciones && (
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="ids-alert-info-soft mb-0">
                                                        <strong>Observaciones</strong><br/>
                                                        {egresoSeleccionado.observaciones}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <div className="small text-muted border rounded p-2 bg-light mb-0">
                                                    <i className="fas fa-info-circle mr-1"></i> Para ver el documento completo con todos los detalles, use los botones Imprimir o PDF.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalEgreso(false)}>
                                    Cerrar
                                </button>
                                <button type="button" className="btn btn-primary" onClick={imprimirEgreso}>
                                    <i className="fas fa-print"></i> Imprimir
                                </button>
                                <button type="button" className="btn btn-danger" onClick={imprimirEgreso}>
                                    <i className="fas fa-file-pdf"></i> PDF
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Debug */}
            {showModalDebug && (
                <div className="modal fade show ids-ds-modal" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.45)'}} tabIndex="-1">
                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                        <div className="modal-content border-0">
                            <div className={`modal-header ${debugType === 'success' ? 'ids-ds-head' : 'ids-ds-head-error'}`}>
                                <h4 className="modal-title">
                                    {debugType === 'success' ? (
                                        <><i className="fas fa-check-circle mr-2 text-success"></i>Envío exitoso</>
                                    ) : (
                                        <><i className="fas fa-exclamation-triangle mr-2 text-danger"></i>Error en el envío</>
                                    )}
                                </h4>
                                <button type="button" className="close" onClick={() => setShowModalDebug(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {debugType === 'success' ? (
                                    <div>
                                        <div className="ids-alert-info-soft mb-3">
                                            <h5 className="mb-0"><i className="fas fa-check-circle mr-1"></i> {debugData?.message}</h5>
                                        </div>
                                        <div className="card ids-debug-card mb-0">
                                            <div className="card-header">
                                                <strong><i className="fas fa-info-circle mr-2 text-info"></i>Detalles de la respuesta</strong>
                                            </div>
                                            <div className="card-body">
                                                <p className="mb-2"><strong>CUFE:</strong> <code className="small">{debugData?.cufe}</code></p>
                                                <p className="mb-0"><strong>Estado del documento:</strong>
                                                    <span className="badge badge-success ml-2">Enviado a DIAN</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div className="ids-ds-alert-caution mb-3">
                                            <h5 className="mb-0"><i className="fas fa-exclamation-triangle mr-1"></i> {debugData?.message}</h5>
                                        </div>
                                        
                                        {debugData?.response && (
                                            <div className="card ids-debug-card mb-3">
                                                <div className="card-header">
                                                    <strong><i className="fas fa-exclamation-triangle mr-2 text-warning"></i>Respuesta de la DIAN</strong>
                                                </div>
                                                <div className="card-body">
                                                    <pre className="ids-json-pre mb-0" style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{JSON.stringify(debugData.response, null, 2)}</pre>
                                                </div>
                                            </div>
                                        )}
                                        
                                        {debugData?.json_enviado && (
                                            <div className="card ids-debug-card mb-0">
                                                <div className="card-header">
                                                    <strong><i className="fas fa-code mr-2 text-info"></i>JSON enviado a la DIAN</strong>
                                                </div>
                                                <div className="card-body">
                                                    <pre className="ids-json-pre mb-0" style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{JSON.stringify(debugData.json_enviado, null, 2)}</pre>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default InformacionDocumentoSoporte;
